module.exports = __webpack_public_path__ + "img/tapak-semaian-kelapa-sawit-2.0fd2c3ec.jpeg";